import { SubscriptionTier } from '@heidi/schema/ml-scribe';

/**
 * Clinician Max credit usage surfaces — free, Pro, Clinician Pro. Not
 * Practice / Clinician Pro Plus. Shared by the side-nav popover and the
 * billing usage section so the two never disagree about who is in the cohort.
 *
 * An unresolved tier (null/undefined while `useQueryUserTier` loads) is OUT:
 * the surface waits for an explicit tier rather than flashing for a user who
 * resolves to a Practice-plus tier.
 */
export function isCreditUsageSurfaceTier(
  tier: SubscriptionTier | null | undefined
): boolean {
  return (
    tier === SubscriptionTier.FREE ||
    tier === SubscriptionTier.PRO ||
    tier === SubscriptionTier.CLINICIAN_PRO
  );
}
